import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex align-center justify-center",
    style: _normalizeStyle({minHeight: _ctx.minHeight})
  }, [
    _createVNode(_component_v_progress_circular, {
      indeterminate: "",
      size: "64",
      color: "primary"
    })
  ], 4))
}